var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.625 12.25C6.625 11.7668 7.01675 11.375 7.5 11.375C7.98325 11.375 8.375 11.7668 8.375 12.25C8.375 12.7332 7.98325 13.125 7.5 13.125C7.01675 13.125 6.625 12.7332 6.625 12.25Z",
    fill: "#D80587"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 14.875C7.01675 14.875 6.625 15.2668 6.625 15.75C6.625 16.2332 7.01675 16.625 7.5 16.625C7.98325 16.625 8.375 16.2332 8.375 15.75C8.375 15.2668 7.98325 14.875 7.5 14.875Z",
    fill: "#D80587"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 12.25C10.125 11.7668 10.5168 11.375 11 11.375C11.4832 11.375 11.875 11.7668 11.875 12.25C11.875 12.7332 11.4832 13.125 11 13.125C10.5168 13.125 10.125 12.7332 10.125 12.25Z",
    fill: "#D80587"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11 14.875C10.5168 14.875 10.125 15.2668 10.125 15.75C10.125 16.2332 10.5168 16.625 11 16.625C11.4832 16.625 11.875 16.2332 11.875 15.75C11.875 15.2668 11.4832 14.875 11 14.875Z",
    fill: "#D80587"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.625 12.25C13.625 11.7668 14.0168 11.375 14.5 11.375C14.9833 11.375 15.375 11.7668 15.375 12.25C15.375 12.7332 14.9833 13.125 14.5 13.125C14.0168 13.125 13.625 12.7332 13.625 12.25Z",
    fill: "#D80587"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 14.875C14.0168 14.875 13.625 15.2668 13.625 15.75C13.625 16.2332 14.0168 16.625 14.5 16.625C14.9833 16.625 15.375 16.2332 15.375 15.75C15.375 15.2668 14.9833 14.875 14.5 14.875Z",
    fill: "#D80587"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.75 1.75C5.75 1.26675 6.14175 0.875 6.625 0.875C7.10825 0.875 7.5 1.26675 7.5 1.75V2.625H14.5V1.75C14.5 1.26675 14.8918 0.875 15.375 0.875C15.8583 0.875 16.25 1.26675 16.25 1.75V2.625H17.125C18.5748 2.625 19.75 3.80025 19.75 5.25V17.5C19.75 18.9497 18.5748 20.125 17.125 20.125H4.875C3.42525 20.125 2.25 18.9497 2.25 17.5V5.25C2.25 3.80025 3.42525 2.625 4.875 2.625H5.75V1.75ZM14.5 4.375V5.25C14.5 5.73325 14.8918 6.125 15.375 6.125C15.8583 6.125 16.25 5.73325 16.25 5.25V4.375H17.125C17.6083 4.375 18 4.76675 18 5.25V7.875H4V5.25C4 4.76675 4.39175 4.375 4.875 4.375H5.75V5.25C5.75 5.73325 6.14175 6.125 6.625 6.125C7.10825 6.125 7.5 5.73325 7.5 5.25V4.375H14.5ZM4 9.625V17.5C4 17.9832 4.39175 18.375 4.875 18.375H17.125C17.6083 18.375 18 17.9832 18 17.5V9.625H4Z",
    fill: "#D80587"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarSmall);
export default __webpack_public_path__ + "static/media/calendar-small.d41149b28c844c643b2cf3bd141fe756.svg";
export { ForwardRef as ReactComponent };